import React from "react";
import xamarin from "../../images/home/technology/xamarin.svg";
import android from "../../images/home/technology/android.svg";
import apple from "../../images/home/technology/apple.svg";
import react from "../../images/home/technology/react.svg";
import angular from "../../images/home/technology/angular.svg";
import dotnet from "../../images/home/technology/dotnet.svg";
import flutter from "../../images/home/technology/flutter.svg";
import php from "../../images/home/technology/php.svg";
import nodejs from "../../images/home/technology/nodejs.svg";
import python from "../../images/home/technology/python.svg";
import { Link } from "react-router-dom";

const Technology = () => {
  return (
    <>
      <section className="techSection" style={{ backgroundColor: '#f6f8fb' }}>
        <div className="container position-relative" style={{ zIndex: 1 }}>
          <div className="row">
            <div className="col-md-12">
              <div className="heading">
                <h3 data-aos="slide-right">
                  <span>Skills </span> We Offer
                </h3>
                <p data-aos="zoom-in">We offer access to highly skilled and dedicated remote developers across <strong>20+ in-demand technologies</strong>. Our team brings proven expertise in <strong>Python, Microsoft .NET Core, React.js, Node.js, Angular, Laravel, React Native, iOS, Android</strong>, and more — ensuring you get reliable talent that delivers results from day one.</p>
                <Link data-aos="slide-up" to="/HireDeveloper" className="btn">
                  <span>Hire Top Developer</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="rectLogo rect1">
            <img src={python} alt="Xamarin Development" />
          </div>
          <div className="rectLogo rect2">
            <img src={android} alt="Android Development" />
          </div>
          <div className="rectLogo rect3">
            <img src={apple} alt="iOS Development" />
          </div>
          <div className="rectLogo rect4">
            <img src={react} alt="React Development" />
          </div>
          <div className="rectLogo rect5">
            <img src={angular} alt="Angular Development" />
          </div>
          <div className="rectLogo rect6">
            <img src={dotnet} alt="DotNet Development" />
          </div>
          <div className="rectLogo rect7">
            <img src={flutter} alt="Flutter Development" />
          </div>
          <div className="rectLogo rect8">
            <img src={php} alt="PHP Development" />
          </div>
          <div className="rectLogo rect9">
            <img src={nodejs} alt="NodeJS Development" />
          </div>
        </div>
      </section>
    </>
  );
};

export default Technology;
